import myaxios from './axios'
import axios from 'axios'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'

const request = (method, url, params, isJSON = true) => {
  return new Promise((resolve, reject) => {
    const requestObj = { url, method }
    const key = isJSON ? 'data' : 'params'
    requestObj[key] = params
    myaxios(requestObj)
      .then(res => {
        resolve({
          msg: res.data.msg,
          data: res.data.data,
          code: res.data.code
        })
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const post = (url, params, isJSON = true) => {
  return request('post', url, params, isJSON)
}

export const get = (url, params) => {
  return request('get', url, params, false)
}

// 获取类型
export const getObjType = obj => {
  let toString = Object.prototype.toString
  let map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  return map[toString.call(obj)]
}

// 对象深拷贝
export const deepClone = data => {
  let type = getObjType(data)
  let obj
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    // 不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (let i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (let key in data) {
      obj[key] = deepClone(data[key])
    }
  }
  return obj
}

/**
 * 根据后端返回的文件路径下载文件(目的: 自定义下载的文件名称)
 * param1: blob对象
 * param2: 文件名称
 */
export const downloadByLink = (link, fileName) => {
  const xhr = new XMLHttpRequest()
  xhr.open('GET', link, true)
  xhr.responseType = 'blob'
  xhr.onload = () => {
    if (xhr.status === 200) {
      const blob = xhr.response
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        const body = document.querySelector('body')
        link.href = window.URL.createObjectURL(blob) // 创建对象url
        link.download = fileName
        link.style.display = 'none'
        body.appendChild(link)
        link.click()
        body.removeChild(link)
        window.URL.revokeObjectURL(link.href) // 通过调用 URL.createObjectURL() 创建的 URL 对象
      }
    } else {
      window.open(link, '_blank')
    }
  }
  xhr.send()
}

// 下载后端返回的文件流
export const downloadFile = (url, params, type, fileName, isJSON) => {
  let newaxios = axios.create()
  let config = {
    method: 'post',
    url,
    responseType: 'blob',
    timeout: 300000, // 5分钟
    headers: {
      'Blade-Auth': 'bearer ' + getToken()
    }
  }
  if (isJSON === false) {
    // 不为application/json
    config.params = params
  } else {
    config.data = params
  }
  return newaxios(config).then(res => {
    if (res.status !== 200) {
      Message({
        type: 'error',
        message: '导出失败，请稍后重试',
        duration: 3000
      })
      return
    }
    if ('msSaveOrOpenBlob' in navigator) {
      // 兼容ie
      window.navigator.msSaveOrOpenBlob(res.data, fileName)
      return
    }
    let blob = new Blob([res.data], { type })
    let url = window.URL.createObjectURL(blob) // 创建下载链接
    let a = document.createElement('a')
    a.download = fileName
    a.href = url
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url) // 释放掉blob对象
  })
}

// 处理富文本 只返回文本
export const handleContent = content => {
  content = content.replace(/(\n)|(\t)|(\r)|<\/?[^>]*>|(\s*)/g, '')
  content = content.replace(/&emsp;|&thinsp;|&zwnj;|&zwj;|&ldquo;|&rdquo;|&nbsp;/g, '')
  return content
}
class BackTop {
  constructor(scrollTop, timer = null) {
    this.scrollTop = scrollTop
    this.timer = timer
  }

  backTop() {
    this.timer = setInterval(() => {
      let ispeed = Math.floor(-this.scrollTop / 5)
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop + ispeed
      if (this.scrollTop === 0) {
        clearInterval(this.timer)
      }
    }, 1000 / 60)
  }

  getScrollTop() {
    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
  }
}
export const backTopObj = new BackTop(window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop)
